import VueTypes from 'vue-types';

export const ALERT_TYPES = {
  INFO: 'info',
  SUCCESS: 'success',
  ERROR: 'error',
};

export const alertProps = {
  id: VueTypes.number.isRequired,
  type: VueTypes.oneOf(Object.values(ALERT_TYPES)).def(ALERT_TYPES.INFO),
  message: VueTypes.string.def(''),
};
export const VTAlert = VueTypes.shape(alertProps);
export const VTAlerts = VueTypes.arrayOf(VTAlert);
export const alertListProps = {
  items: VTAlerts.def([]),
};
